import type { StoreStatus } from '~/services/api/interfaces/Store'
import { StoreStatusValues } from '~/services/api/interfaces/Store'

export const normalizeStoreStatus = (status: unknown): StoreStatus | null =>
  StoreStatusValues.find((value) => value === status) ?? null
